import Flickity from "flickity"


const initAwardsSlider = () => {

    const awardSlider = document.querySelector('.js-awards-slider')

    if (awardSlider) {
        new Flickity(awardSlider, {
            cellAlign: 'left',
            contain: true,
            imagesLoaded: true,
            prevNextButtons: false,
            adaptiveHeight: true,
            pageDots: true
        });
    }
}

export {initAwardsSlider}
